module.exports = __webpack_public_path__ + "img/2C.9062ac4c.jpg";